module.exports = __webpack_public_path__ + "img/DE02018.509a3d51.png";